module.exports = __webpack_public_path__ + "img/imiwin-support.0a1c4ccc.png";